import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-team-stacking/actions';

class PPLinesChecking extends Component {
    onChange(ppLine, isChecked) {
        this.props.dispatch(Action.setPPLinesForStackNumber({[ppLine]: isChecked}, this.props.stackNumber));
    }

    render() {
        const {stackNumber, stacking} = this.props;
        const ppLines = stacking.getPPLinesByStackNumber(stackNumber);

        return (
            <div className="chk-group-container">
                <strong className="chk-group-title">PP Lines:</strong>
                <div className="chk-group">
                    {Object.keys(ppLines).map((ppLine) => {
                        let isChecked = ppLines[ppLine];
                        return (
                            <label key={ppLine}>
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => ::this.onChange(ppLine, e.target.checked)}
                                />
                                <span>{ppLine}</span>
                            </label>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {nhlTeamStacking} = state;

    return {
        stacking: nhlTeamStacking,
    };
}

export default connect(mapStatesToProps)(PPLinesChecking);
